import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mixed_media_settings_pop_up = _resolveComponent("mixed-media-settings-pop-up")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_app_network_confirm_pop_up = _resolveComponent("app-network-confirm-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_mixed_media_settings_pop_up, {
          key: 0,
          class: "media-popup",
          file: _ctx.currentItem,
          type: _ctx.currentItemType,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closePopUp'))),
          onOpenMovePopUp: _ctx.openMovePopUp,
          onDeleteMedia: _ctx.openQuestionPopUp,
          onSaveMediaAsCopy: _ctx.saveMediaAsCopy,
          onRemoveSharing: _ctx.removeMediaFromSharing,
          onOnInfo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPopUp(_ctx.currentItem.type === 'PHOTO' ? _ctx.BOTTOM_POPUP_TYPES.PHOTO_INFO : _ctx.BOTTOM_POPUP_TYPES.FILE_INFO))),
          onOpenFileRenamePopUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openFileRename'))),
          onOnShare: _ctx.onShare
        }, null, 8, ["file", "type", "onOpenMovePopUp", "onDeleteMedia", "onSaveMediaAsCopy", "onRemoveSharing", "onOnShare"]))
      : _createCommentVNode("", true),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deletePhoto
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isSharePopUp)
      ? (_openBlock(), _createBlock(_component_share_pop_up, {
          key: 2,
          item: _ctx.currentItem!,
          "item-type": _ctx.SHARE_TYPES[_ctx.currentItemType],
          onHide: _ctx.onSharePopupHide,
          onOnShareByMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-close'))),
          class: "share-popup",
          onClick: _withModifiers(_ctx.onSharePopupHide, ["stop"])
        }, null, 8, ["item", "item-type", "onHide", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.confirmUnsharing)
      ? (_openBlock(), _createBlock(_component_app_network_confirm_pop_up, {
          key: 3,
          onUnshare: _ctx.unshareCase,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmUnsharing = false)),
          "case-to-unshare": _ctx.caseToUnshare
        }, null, 8, ["onUnshare", "case-to-unshare"]))
      : _createCommentVNode("", true),
    (_ctx.isMoveToPopUp)
      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
          key: 4,
          item: _ctx.currentItem,
          "item-type": _ctx.currentItemType,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isMoveToPopUp = false)),
          onUpdateLocation: _ctx.updateLocation,
          class: "move-to"
        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
      : _createCommentVNode("", true)
  ]))
}